module.exports = __webpack_public_path__ + "static/img/weiduanleft.577c832.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeback/weiduanleft.gif
// module id = 1sfj
// module chunks = 1